import React, { FC, useEffect, useState } from 'react';
import { isTouchDevice, Tooltip } from '@investoro/core';
import styled from 'styled-components';

import Icon, { IconEnum } from 'components/common/Icon';

const TitleWrapper = styled.div<{ isInModal?: boolean }>`
    display: inline;
    padding: ${(props) => props.isInModal ? '10px 15px' : '0'};
    color: var(--color-primary);
    
    span.text-wrapper { 
        border-radius: 8px;
        padding: 0 5px;
        background-color: var(--background-color-ai);
        font-style: italic;
        display: inline-flex;
        align-items: center;
        gap: 3px;
        cursor: pointer;
       
        .icon {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            background: transparent;
        }

        .icon img {
            height: 18px;
            margin-left: 3px;    
        }        
    }
`;

const TextValue = styled.span<{ isBlurred?: boolean}>`
    filter: ${({ isBlurred }) => isBlurred ? 'blur(3px)' : 'none'}
`;

interface TtileAiWithTooltipProps {
    title?: string;
    additionalTitle?: string;
    tooltipText?: string;
    showIcon?: boolean;
    isInModal?: boolean;
    hasPredictionRole?: boolean;
}

const TitleWithSecondValueAndTooltip: FC<TtileAiWithTooltipProps> = ({ title, tooltipText = 'Dane wygenerowane za pomocą AI', showIcon = true, additionalTitle, isInModal, hasPredictionRole }) => {
    const [showTooltip, setShowTooltip] = useState(false);
    const [referenceElement, setReferenceElement] = useState<HTMLElement | null>(null);
    const [isTouch, setIsTouch] = useState(false);

    useEffect(() => {
        setIsTouch(isTouchDevice());
    }, []);

    const handleTooltipToggle = (e: React.MouseEvent | React.TouchEvent) => {
        e.stopPropagation();
        setShowTooltip((prev) => !prev);
    };

    const finalTooltipText = <div><p>{tooltipText}</p>{!hasPredictionRole && <p>Opcja niedostępna w wybranym pakiecie</p>}</div>;

    return (
        <>
            <TitleWrapper isInModal={isInModal}>
                {title && title}
                {additionalTitle && <span
                    className="text-wrapper"
                    onClick={handleTooltipToggle}
                    onMouseEnter={() => !isTouch && setShowTooltip(true)}
                    onMouseLeave={() => !isTouch && setShowTooltip(false)}
                    ref={setReferenceElement}
                >
                    <TextValue isBlurred={!hasPredictionRole}>{additionalTitle}</TextValue>
                    {showIcon && <Icon icon={IconEnum.AI_STARS} />}
                </span>}
            </TitleWrapper>
            <Tooltip showTooltip={showTooltip} text={finalTooltipText} referenceElement={referenceElement}/>
        </>
    );
};

export default TitleWithSecondValueAndTooltip;
